import React from 'react';
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import style from './ThirdStep.module.scss';
import {Container, Row, Col} from "react-bootstrap";

class ThirdStep extends React.Component {

  redirectToHome() {
    this.props.history.push('/');
  }

  render() {
    return (
        <Container>
          <Row className={'mb-2 text-center'}>
            <Col xs={12} className={'d-flex justify-content-center'}>
              <div className={`${style.check} d-flex justify-content-center align-items-center`}>
                <i className={'icon-tick'} />
              </div>
            </Col>
            <Col xs={12} className={`d-flex justify-content-center ${style.content}`}>
              <p>
                لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و متخصصان را می طلبد، تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی، و فرهنگ پیشرو در زبان فارسی ایجاد کرد، در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها، و شرایط سخت تایپ به پایان رسد و زمان مورد نیاز شامل حروفچینی دستاوردهای اصلی، و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.
              </p>
            </Col>
            <Col xs={12} className={style.button_container} >
              <button type="button" className={`btn btn-primary btn-sm ${style.button}`} onClick={() => {
                this.redirectToHome();
              }}>
                بازگشت به صفحه اول
              </button>
            </Col>
          </Row>
        </Container>
    );
  }
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ThirdStep));
